// "New game" in the end windows of the card games at a table (Kierki, Makao; the Games window's "Other card games").
// After a long game the page reloads, as the solitaires' Win window does (the ads refresh, owner 2026-10-26). A short
// one starts the next game at once, without the reload (owner 2026-10-27: a Makao deal often ends within a minute,
// and a reload each time meant waiting and tapping through the start again).
import { env } from '../env';

/** A game this short, from its deal to its end, starts the next one without a reload. */
export const SHORT_GAME_MS = 2 * 60_000;

export const isShortGame = (startedAt: number, endedAt: number | null): boolean => endedAt !== null && endedAt - startedAt < SHORT_GAME_MS;

/** A full reload into `game` (a URL that differs only by its hash does not reload). */
export function reloadForNewGame(game: string): void {
  const target = `${env.fullAddr}#${game}`;
  if (location.href.split('#')[0] === target.split('#')[0]) {
    location.hash = game;
    location.reload();
  } else location.href = target;
}
